import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import NeedSupport from './_components/NeedSupport';
import AccountSummary from 'components/PersonalAccount/AccountSummary/AccountSummary';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function PersonalAccount(): JSX.Element {
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search);

  useGtmPageView(GTM_PAGE_OTHER, '');

  return (
    <div className={styles.page}>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', {
            title: t('PERSONAL_ACCOUNT_META_TITLE'),
          })}
        </title>
      </Helmet>
      <NeedSupport />
      {queryParams?.get('sipsstatus') === 'ok' && (
        <div className={styles.sipsMessage + ' ' + styles.valid}>
          {t('LABEL_SIPS_VALID')}
        </div>
      )}
      {queryParams?.get('sipsstatus') === 'ko' && (
        <div className={styles.sipsMessage + ' ' + styles.error}>
          {t('LABEL_SIPS_ERROR')}
        </div>
      )}
      <h2 className={styles.title}>{t('LABEL_ACCOUNT_SUMMARY')}</h2>
      <AccountSummary />
    </div>
  );
}
